// ==================================================
//  モバイル判定イベント
// ==================================================
function is_mobile() {
  const intFrameWidth = window.innerWidth;
  return intFrameWidth <= 767 ? true : false;
}

// ==================================================
//  ヘッダーメニューボタン（モバイル）
// ==================================================
const menu = document.querySelector(".header_menu-js");
const menuActiveClass = "header_menu-js-active";
const menuButton = document.querySelector(".header_menuButton-js");
const menuButtonActiveClass = "header_menuButton-js-active";
const scrollBody = document.querySelector("body");
const scrollBodyActiveClass = "body-js-active";
function headerMenuToggle() {
  menu.classList.toggle(menuActiveClass);
  menuButton.classList.toggle(menuButtonActiveClass);
  scrollBody.classList.toggle(scrollBodyActiveClass);
}
menuButton.addEventListener("click", (event) => {
  headerMenuToggle();
});

// ==================================================
//  アンカーリンクのスムーススクロール
// ==================================================
const anchors = document.querySelectorAll('a[href^="#"]');
let adjuster = 60;
if (is_mobile) {
  adjuster = 40;
}
const headerHeight = document.querySelector("header").offsetHeight + adjuster;
const urlHash = location.hash;

for (let i = 0; i < anchors.length; i++) {
  anchors[i].addEventListener("click", (e) => {
    e.preventDefault();

    /* ==================================================
     * ヘッダーメニューが開いていたら閉じる
     */
    if (menu.classList.contains(menuActiveClass)) {
      headerMenuToggle();
    }
    /* ================================================== */

    const href = anchors[i].getAttribute("href");
    if (href !== "#top" && href !== "#") {
      const target = document.getElementById(href.replace("#", ""));
      const position = window.pageYOffset + target.getBoundingClientRect().top - headerHeight;
      window.scroll({
        top: position,
        behavior: "smooth",
      });
    } else {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    }
  });
}

// ==================================================
//  アンカーリンクのページ遷移位置調整
// ==================================================
window.addEventListener("load", (event) => {
  const url = location.href;
  let adjuster = 60;
  if (is_mobile) {
    adjuster = 40;
  }
  let headerHeight = document.querySelector("header").offsetHeight + adjuster;

  if (url.indexOf("#") != -1) {
    const anchor = url.split("#");
    const position = Math.floor(document.getElementById(anchor[anchor.length - 1]).getBoundingClientRect().top + window.scrollY) - headerHeight;
    window.scroll({
      top: position,
      behavior: "auto",
    });
  }
});

// ==================================================
//  スクロールと連動したアニメーション
// ==================================================
const callback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("visibled");
    }
  });
};
const options = {
  root: null,
  rootMargin: "20% 0px 0px 0px",
  threshold: 0,
};
let observer = new IntersectionObserver(callback, options);
const animationItems = document.querySelectorAll(".js-cliptext");
animationItems.forEach((item) => {
  observer.observe(item);
});

// ==================================================
//  追従要素の横スクロール連動
// ==================================================
const fixedScroll = document.querySelector(".fixedScroll-js");
window.addEventListener("scroll", () => {
  fixedScroll.style.left = -window.scrollX + "px";
});

//モーダルボタン設定
window.addEventListener("load", (event) => {
  const swiper = new Swiper(".swiper", {
    autoHeight: true,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  const modalButtons = document.querySelectorAll(".js-modal-buton");
  modalButtons.forEach((modalButton) => {
    modalButton.addEventListener("click", () => {
      //ボタンの番号をスライダーへ保存
      const m = modalButton.dataset.micromodalTrigger;
      const n = document.getElementById(m);
      n.setAttribute("aria-hidden", "false");
      n.classList.add("is-open");
      const i = modalButton.dataset.index;
      const t = m.split("-");
      swiper[t[1]].slideTo(i);
    });
  });
});

const closeBtn = document.querySelectorAll(".modal__close");
closeBtn.forEach((c) => {
  c.addEventListener("click", () => {
    const n = c.parentNode.parentNode.parentNode.parentNode;
    n.setAttribute("aria-hidden", "true");
    n.classList.remove("is-open");
  });
});
const mod = document.querySelectorAll(".modal__overlay");
const c = document.querySelectorAll(".modal__container");
mod.forEach((o) => {
  o.addEventListener("click", () => {
    const p = o.parentNode;
    p.setAttribute("aria-hidden", "true");
    p.classList.remove("is-open");
  });
});
c.forEach((i) => {
  i.addEventListener("click", (event) => {
    event.stopPropagation();
  });
});

document.addEventListener("scroll", () => {
  const s = window.scrollY;
  const header = document.querySelector(".header");
  if (header) {
    if (is_mobile()) {
      if (s > 60) {
        header.classList.add("c-header_fix");
      } else {
        header.classList.remove("c-header_fix");
      }
    } else {
      if (s > 119) {
        header.classList.add("c-header_fix");
      } else {
        header.classList.remove("c-header_fix");
      }
    }
  }
});

const accordionBtns = document.querySelectorAll(".question_anser dt");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

$(document).ready(function () {
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");
    $(this).addClass("current");
    $('li[data-tab="' + tab_id + '"]').addClass("current");
    $("#" + tab_id).addClass("current");

    // Scroll
    $("html,body").animate({ scrollTop: $(".tab-content.current").offset().top - 150 }, 600);
  });
});
